import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import { Flex } from '@repo/pandacss/jsx';
import type { CSSProperties } from 'react';
import { Typography } from '../Typography';
import { badge } from './badge.recipe';
import type { BadgeProps } from './types';
export function Badge(t0) {
  const $ = _c(45);
  let className;
  let containerProps;
  let cssProp;
  let icon;
  let iconNode;
  let style;
  let t1;
  let text;
  let typographyProps;
  if ($[0] !== t0) {
    ({
      text,
      colorVariant: t1,
      icon,
      iconNode,
      typographyProps,
      css: cssProp,
      className,
      style,
      ...containerProps
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = containerProps;
    $[3] = cssProp;
    $[4] = icon;
    $[5] = iconNode;
    $[6] = style;
    $[7] = t1;
    $[8] = text;
    $[9] = typographyProps;
  } else {
    className = $[1];
    containerProps = $[2];
    cssProp = $[3];
    icon = $[4];
    iconNode = $[5];
    style = $[6];
    t1 = $[7];
    text = $[8];
    typographyProps = $[9];
  }
  const colorVariant = t1 === undefined ? "green1" : t1;
  if (!text) {
    return null;
  }
  let T0;
  let T1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let typographyRest;
  if ($[10] !== className || $[11] !== colorVariant || $[12] !== containerProps || $[13] !== cssProp || $[14] !== icon?.IconElement || $[15] !== icon?.className || $[16] !== icon?.css || $[17] !== icon?.dataTestId || $[18] !== icon?.size || $[19] !== icon?.style || $[20] !== iconNode || $[21] !== style || $[22] !== typographyProps) {
    const {
      container: containerSlot,
      icon: iconSlot,
      text: textSlot
    } = badge.raw({
      colorVariant
    });
    const IconElement = icon?.IconElement;
    const {
      css: typographyCss,
      className: typographyClassName,
      ...t8
    } = typographyProps ?? {};
    typographyRest = t8;
    T1 = Flex;
    t4 = cx(css(containerSlot, cssProp), className);
    t5 = style;
    t6 = containerProps;
    t7 = iconNode ?? (IconElement && <IconElement className={cx(css(iconSlot, {
      boxSize: "var(--badge-icon-size)"
    }, icon?.css), icon?.className)} style={{
      "--badge-icon-size": icon?.size ?? "1.5rem",
      ...icon?.style
    } as CSSProperties} data-testid={icon?.dataTestId} />);
    T0 = Typography;
    t2 = "text.bold";
    t3 = cx(css(textSlot, typographyCss), typographyClassName);
    $[10] = className;
    $[11] = colorVariant;
    $[12] = containerProps;
    $[13] = cssProp;
    $[14] = icon?.IconElement;
    $[15] = icon?.className;
    $[16] = icon?.css;
    $[17] = icon?.dataTestId;
    $[18] = icon?.size;
    $[19] = icon?.style;
    $[20] = iconNode;
    $[21] = style;
    $[22] = typographyProps;
    $[23] = T0;
    $[24] = T1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = typographyRest;
  } else {
    T0 = $[23];
    T1 = $[24];
    t2 = $[25];
    t3 = $[26];
    t4 = $[27];
    t5 = $[28];
    t6 = $[29];
    t7 = $[30];
    typographyRest = $[31];
  }
  let t8;
  if ($[32] !== T0 || $[33] !== t2 || $[34] !== t3 || $[35] !== text || $[36] !== typographyRest) {
    t8 = <T0 variant={t2} className={t3} {...typographyRest}>{text}</T0>;
    $[32] = T0;
    $[33] = t2;
    $[34] = t3;
    $[35] = text;
    $[36] = typographyRest;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  let t9;
  if ($[38] !== T1 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6 || $[42] !== t7 || $[43] !== t8) {
    t9 = <T1 className={t4} style={t5} {...t6}>{t7}{t8}</T1>;
    $[38] = T1;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
  } else {
    t9 = $[44];
  }
  return t9;
}
export type { BadgeProps } from './types';